import { createAction } from '@ngrx/store';

export const updateImageView = createAction('[Cast Profile] Update Image View');
